import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  RoomBpmByRunTypePayload,
  RoomBpmByRunTypeResponse,
  RoomBpmByRunTypeSingleResponse
} from 'Interfaces/ReferenceInterfaces/RoomBpmByRunTypeInterface';

export const roomBpmByRunTypeServices = {
  getAllRoomBpmByRunTypes: (page = 1, pageSize = 10000): Promise<RoomBpmByRunTypeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = 'pps/room-bpm-by-run-types';
        const { data } = await getRequest<RoomBpmByRunTypeResponse>(url);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getRoomBpmByRunTypeById: (id: number): Promise<RoomBpmByRunTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<RoomBpmByRunTypeSingleResponse>(
          `pps/room-bpm-by-run-types/${id}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createRoomBpmByRunType: (
    roomBpmByRunTypeData: RoomBpmByRunTypePayload
  ): Promise<RoomBpmByRunTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<RoomBpmByRunTypeSingleResponse>(
          'pps/room-bpm-by-run-types/',
          roomBpmByRunTypeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateRoomBpmByRunType: (
    id: number,
    roomBpmByRunTypeData: RoomBpmByRunTypePayload
  ): Promise<RoomBpmByRunTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<RoomBpmByRunTypeSingleResponse>(
          `pps/room-bpm-by-run-types/${id}/`,
          roomBpmByRunTypeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteRoomBpmByRunType: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/room-bpm-by-run-types/${id}`);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  }
};
